import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { TreeDeciduous, ArrowLeft, Mail, Globe } from 'lucide-react';

const ImpressumPage = () => {
  const { t, language } = useLanguage();

  const content = {
    de: {
      title: 'Impressum',
      responsible: 'Angaben gemäß § 5 TMG',
      company: 'HODEMA edertools AB',
      contact: 'Kontakt',
      disclaimer: 'Haftungsausschluss',
      disclaimerText: 'Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.'
    },
    en: {
      title: 'Imprint',
      responsible: 'Information according to § 5 TMG',
      company: 'HODEMA edertools AB',
      contact: 'Contact',
      disclaimer: 'Disclaimer',
      disclaimerText: 'The contents of our pages were created with the greatest care. However, we cannot guarantee the accuracy, completeness and timeliness of the content.'
    },
    se: {
      title: 'Impressum',
      responsible: 'Information enligt § 5 TMG',
      company: 'HODEMA edertools AB',
      contact: 'Kontakt',
      disclaimer: 'Friskrivning',
      disclaimerText: 'Innehållet på våra sidor skapades med största omsorg. Vi kan dock inte garantera innehållets riktighet, fullständighet och aktualitet.'
    }
  };

  const c = content[language] || content.de;

  return (
    <div className="min-h-screen bg-warm-50">
      <header className="bg-white border-b border-warm-200">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="p-2 rounded-lg bg-primary">
              <TreeDeciduous className="h-5 w-5 text-white" />
            </div>
            <span className="font-serif text-xl font-bold text-primary">ForestHub</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-primary hover:underline mb-8">
          <ArrowLeft className="h-4 w-4" />
          {t('common.back')}
        </Link>

        <h1 className="font-serif text-3xl font-bold text-gray-900 mb-8">{c.title}</h1>

        <div className="space-y-8">
          <div>
            <h2 className="font-semibold text-xl text-gray-900 mb-3">{c.responsible}</h2>
            <p className="text-gray-600">
              <strong>{c.company}</strong><br />
              Sweden
            </p>
          </div>

          <div>
            <h2 className="font-semibold text-xl text-gray-900 mb-3">{c.contact}</h2>
            <div className="space-y-2">
              <a href="mailto:info@hodema.se" className="flex items-center gap-2 text-primary hover:underline">
                <Mail className="h-4 w-4" />
                info@hodema.se
              </a>
              <a href="https://hodema.se" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-primary hover:underline">
                <Globe className="h-4 w-4" />
                hodema.se
              </a>
            </div>
          </div>

          <div>
            <h2 className="font-semibold text-xl text-gray-900 mb-3">{c.disclaimer}</h2>
            <p className="text-gray-600">{c.disclaimerText}</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ImpressumPage;
